//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getconfiglist, deleteconfig } from '@/api/configurationManagement.js';
export default {
  data() {
    return {
      loading: false,
      // 搜索
      form: {
        miniProgramName: '',
      },
      // 数据
      tableData: [],
      page_index: 1,
      page_size: 10,
      total: 0,
      appid: this.$route.query.appid,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 搜索
    handleRest() {
      this.form.miniProgramName = '';
      this.getList();
    },
    // 数据
    async getList() {
      this.loading = true;
      try {
        const data = await getconfiglist({
          app_id: this.appid,
          page_index: this.page_index,
          page_size: this.page_size,
        });
        console.log(data);
        this.total = Number(data.total || 0);
        this.tableData = data.list;
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.$message.error('获取配置列表失败');
        this.loading = false;
      }
    },
    handleCurrent(val) {
      this.page_index = val;
      this.getList();
    },
    getTamplate(row) {
      let json = {};
      try {
        json = JSON.parse(row.content);
      } catch (err) {
        console.log(err);
      }
      if (
        Object.keys(json).some((key) => {
          return !['ext', 'window', 'extAppid'].includes(key);
        })
      ) {
        return '普通模板';
      }
      return '普通模板/标准模板';
    },
    // 查看
    handleClick(row = {}, type = '') {
      const query = {
        appid: this.appid,
      };
      if (row.id) {
        query.id = row.id;
      }
      if (row.id && type) {
        query.type = type;
      }
      this.$router.push({
        name: 'mini-ext-json-detail',
        query,
      });
    },
    del(row) {
      try {
        this.$confirm('确定删除该数据吗？', '删除确认', {
          distinguishCancelAndClose: true,
          confirmButtonText: '删除',
          cancelButtonText: '取消',
        }).then(async () => {
          await deleteconfig({ id: `${row.id}` });
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.page_index = 1;
          this.getList();
        });
      } catch (err) {
        console.log('err:', err);
      }
    },
  },
};
